import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-75" data-mp="1nv1l2blse3ze">
      <Reveal data-id="element-76" data-mp="2bmgpqb11cxdt">
        <h2 id="faq" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-77" data-mp="2flxwr8w422l3">
          Preguntas frecuentes
        </h2>
      </Reveal>

      <div className="mt-5 grid gap-2 lg:grid-cols-2 lg:items-start" data-id="element-78" data-mp="21sq4df07h32c">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={faq.q} className="rounded-xl border border-line bg-surface" data-id="element-79" data-mp="2uhnbqn2vpfgb" data-mpi={i}>
              <h3 data-id="element-80" data-mp="2zc1bf1okq8qs">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left" data-id="element-81" data-mp="1vprdr4ybp2q3">
                  <span className="text-sm md:text-base font-semibold text-ink" data-id="element-82" data-mp="20om6aym3e5ne">
                    {faq.q}
                  </span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-accent transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-83" data-mp="2fbxfitusxdkc" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-84" data-mp="2jd9734x8k8v6">
                {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: EASE
            }} className="overflow-hidden" data-id="element-85" data-mp="u0xme8k7gfne">
                    <p className="px-4 pb-3 text-sm leading-relaxed text-ink-muted" data-id="element-86" data-mp="2z1i523lp8mmz">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}